export default "__VITE_ASSET__518fe54a__"